const styles = {
  root: {
    boxShadow: 'none',
    '&.p0': {
      '& .MuiAccordionDetails-root': {
        paddingY: '16px!important',
      },
    },
  },
  firstIcon: {
    borderRight: '1px solid #E9E9E9',
    pr: { xs: 1, lg: 2 },
    mr: { xs: 1, lg: 2 },
    display: 'flex',
  },
  accordionContent: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      ml: 1,
    },
  },

  formTitle: {
    color: 'secondary.main',
    '&.MuiTypography-h4': {
      fontSize: { xs: '16px!important', lg: 'auto' },
      // width: { xs: '190px!important', sm: 'auto!important', lg: 'auto!important' },
    },
  },
  formTitleValid: {
    color: 'text.primaryDark',
  },
  formTitleInvalid: {
    color: 'text.grey800',
  },
  accordionDetails: {
    borderTop: '1px solid #E9E9E9',
    paddingY: '16px!important',
    paddingX: '0px!important',
  },
}

export default styles
